import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
const ProviderMaintenance = (props) => {
    return (
        <div className='popup-box'>
            <h4 className="title">{props.t('attention')} !</h4>
            <p> {props.t('sorry')}, {props.t('currently_the_game_lobby_is_under_repair_maintenance')}.</p>
            <p> {props.t('thank_you')}.</p>
        </div>
    )
}

ProviderMaintenance.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(ProviderMaintenance);